module.exports = __webpack_public_path__ + "static/media/edit_section_students_video.f820debb.mov";